import axios from 'axios';
import { put, call, takeLeading, delay } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { api_urls } from '../../utils/api-urls';
import Swal from "sweetalert2";
import { get_dashboard } from '../../utils/api-routes';

function* getDashboard() {
  try {
    yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
    const { data } = yield call(axios.get, `${api_urls + get_dashboard}`);
    console.log("Get Dashboard Saga Response ::: ", data)

    if (data?.status) {
      yield delay(500);
      yield put({ type: actionTypes.SET_DASHBOARD, payload: data?.results });
    }
    yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
  } catch (error) {
    yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    console.log("Get Dashboard Saga Error ::: ", error)
  }
}

export default function* dashboardSaga() {
  yield takeLeading(actionTypes.GET_DASHBOARD, getDashboard);
}
